export default {
    darkModeSelected: (state) => state.darkMode,
    menuSidebarCollapsed: (state) => state.menuSidebarCollapsed,
    controlSidebarCollapsed: (state) => state.controlSidebarCollapsed,
    screenSize: (state) => state.screenSize,
    navbarVariant: (state) => state.navbarVariant,
    sidebarSkin: (state) => state.sidebarSkin
};
